import "./Details.css";
import { DetailBoster, DetailGame, RelatedGame } from "../../sections/index";

const Details = () => {
    return (
        <div>
            <DetailBoster />
            <DetailGame />
            <RelatedGame />
        </div>
    );
};

export default Details;
